import script from "./PricingGauge.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingGauge.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/lvr-styles.css?vue&type=style&index=0&id=6babc4dc&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6babc4dc"]])

export default __exports__